import { Button, Grid, DialogActions } from '@mui/material';
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import Loader from 'components/utils/Loading';
import VariantService from 'services/VariantService';
import { InventoryContext } from 'Context/InventoryContext';
import EntitySelector from 'components/utils/EntitySelector/EntitySelector';

export default function CreateVariantMappingDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { onClose, onSuccess, data = {} } = props;
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const {
    baseProducts,
    setBaseProducts,
    variantDimensions,
    setVariantDimensions,
    variantLabels,
    setVariantLabels,
    products,
    setProductVariantMapping,
  } = useContext(InventoryContext);

  const [isLoading, setIsloading] = useState(false);
  const [baseProduct, setBaseProduct] = useState(data?.baseProduct);
  const [dimension, setDimension] = useState(data?.dimension);
  const [label, setLabel] = useState(null);
  const [item, setItem] = useState(data?.item);

  const handleCreateProductVariantMapping = async () => {
    setIsloading(true);
    const data = {};

    const resolveEntity = async (value, createFn, setState, extraData = {}) => {
      if (!value) return null;
      if (typeof value === 'object' && value.id) return value.id;

      const newEntity = await createFn({ name: value, ...extraData });
      setState((prev) => [...prev, newEntity]);
      return newEntity.id;
    };

    try {
      const productId = await resolveEntity(baseProduct, VariantService.createBaseProducts, setBaseProducts);
      const dimensionId = await resolveEntity(dimension, VariantService.createVariantDimension, setVariantDimensions);
      const labelId = await resolveEntity(label, VariantService.createVariantLabel, setVariantLabels, {
        dimension_id: dimensionId,
      });

      if (productId) data.product_id = productId;
      if (labelId) data.label_id = labelId;
      if (item?.id) data.item_id = item.id;

      const mapping = await VariantService.createProductVariantMappings(data);
      setProductVariantMapping((prev) => [...prev, mapping]);

      postAlertMessage({ text: 'Variant mapping created successfully', type: 'success' });
      if (onSuccess) {
        onSuccess(mapping);
      }
      onClose();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }

    setIsloading(false);
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <Loader isOpen={isLoading || baseProducts === null || variantDimensions === null || variantLabels === null} />
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Create item variant')}</h2>
          <CloseIcon onClick={onClose} />
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="top" spacing={2}>
            <Grid item xs={12}>
              <EntitySelector
                entityType="product"
                entities={baseProducts}
                selectedEntity={baseProduct}
                onEntitySelect={(val) => setBaseProduct(val)}
              />
            </Grid>
            <Grid item xs={12}>
              <EntitySelector
                entityType="dimension"
                entities={variantDimensions}
                selectedEntity={dimension}
                onEntitySelect={(val) => setDimension(val)}
              />
            </Grid>
            <Grid item xs={12}>
              <EntitySelector
                entityType="label"
                entities={variantLabels.filter((vl) => vl?.dimension?.id === dimension?.id)}
                selectedEntity={label}
                disabled={!dimension}
                onEntitySelect={(val) => setLabel(val)}
              />
            </Grid>
            <Grid item xs={12}>
              <EntitySelector
                entityType="item"
                entities={products}
                selectedEntity={item}
                onEntitySelect={(val) => setItem(val)}
                disableCreate={true}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small" onClick={onClose}>
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={isLoading || baseProduct === null || label === null || item === null || dimension === null}
              onClick={handleCreateProductVariantMapping}
            >
              {tCommon('Submit')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
